import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper } from '@mui/material';
import { t } from 'i18next'
import { THubstripeCustomer } from '../../../shared/types/hubstripeCustomer.type'
import BillingInvoicesItemsRow from './BillingInvoicesItemsRow';

type BillingInvoicesItemsTableProps = {
    invoices: any;
    creditNotes: any;
    cegidDocs: any;
    paymentMethods: any;
    customer: THubstripeCustomer
}

function BillingInvoicesItemsTable({ invoices, creditNotes, cegidDocs, paymentMethods, customer }: BillingInvoicesItemsTableProps) {

    let creditNotesArray = creditNotes?.map((item: any) => {
        return ({
            ...item, cegidDocs: cegidDocs.filter((doc: any) => doc.ref == item.number)
        })
    })
    let invoicesArray = invoices?.map((item: any) => {
        return ({
            ...item, creditNotes: creditNotesArray.filter((creditNote: any) => creditNote.invoice == item.id), cegidDocs: cegidDocs.filter((doc: any) => doc.ref == item.number)
        })
    })

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: '50px' }} />
                        {["billing:invoices_amount", "billing:invoices_date", "billing:invoices_status", "billing:invoices_sales_order", "billing:invoices_invoice"].map((title) => (
                            <TableCell align="center">
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                    {t(title)}
                                </Typography>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invoicesArray.map((row: any) => (
                        <BillingInvoicesItemsRow key={row.id} row={row} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default BillingInvoicesItemsTable;
